import { DefaultSettings } from "../../../../settings/settings-util";

type StateLocationSettings = DefaultSettings["stateLocations"];
type ClassNamesSettings = DefaultSettings["classNames"];
type LiveChatClassNames = DefaultSettings["classNames"]["livechat"];
type ElementIdsSettings = DefaultSettings["elementIds"];
type TextConstantsSettings = DefaultSettings["textConstants"];

interface EndChatWarningOverlayStateLocationSettings extends StateLocationSettings {
    EndChatWarning: {
        Base: string;
        Visible: string;
    };
}

interface EndChatWarningOverlayLiveChatClassNamesSettings extends LiveChatClassNames {
    endChatWarning: string;
    endChatWarningButtonWrap: string;
    endChatWarningNoButton: string;
    endChatWarningPad: string;
    endChatWarningShadow: string;
    endChatWarningText: string;
    endChatWarningYesButton: string;
}

interface EndChatWarningOverlayClassNamesSettings extends ClassNamesSettings {
    livechat: EndChatWarningOverlayLiveChatClassNamesSettings;
}

interface EndChatWarningOverlayElementIdsSettings extends ElementIdsSettings {
    endChatWarningTextId: string;
}

interface EndChatWarningOverlayTextContantsSettings extends TextConstantsSettings {
    endChatWarningNoTitle: string;
    endChatWarningText: string;
    endChatWarningYesTitle: string;
}

export interface EndChatWarningOverlayDefaultSettings extends DefaultSettings {
    classNames: EndChatWarningOverlayClassNamesSettings;
    elementIds: EndChatWarningOverlayElementIdsSettings;
    stateLocations: EndChatWarningOverlayStateLocationSettings;
    textConstants: EndChatWarningOverlayTextContantsSettings;
}


const settings = {
    classNames: {
        livechat: {
            endChatWarning: "alme--window--end-chat--warning",
            endChatWarningButtonWrap: "alme--window--end-chat--warning__button__wrap",
            endChatWarningNoButton: "alme--window--end-chat--warning__no__button",
            endChatWarningPad: "alme--window--end-chat--warning__pad",
            endChatWarningShadow: "alme--window--end-chat--warning__shadow",
            endChatWarningText: "alme--window--end-chat--warning__text",
            endChatWarningYesButton: "alme--window--end-chat--warning__yes__button",
        },
    },
    elementIds: {
        endChatWarningTextId: "alme-window-end-chat-warning-text",
    },
    endChatWarning: {
        isWarningEnabled: false,
    },
    stateLocations: {
        Window: {
            Base: "Window",
        },
        EndChatWarning: {
            Base: "EndChatWarning",
            Visible: "visible",
        },
    },
    textConstants: {
        endChatWarningNoTitle: "No",
        endChatWarningText: "Are you sure you want to end your live chat session?",
        endChatWarningYesTitle: "Yes",
    },
} as unknown as EndChatWarningOverlayDefaultSettings;

export default settings;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-endchat-warning-overlay/src/settings/default.ts